import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  /**
   * Returns the current domain where the app is running
   * This method does not take any params and returns a string whit the full domain,
   * including protocol, domain name and port
   *
   * @return {string}
   */
  get getDomain(): string {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    return `${protocol}${host}:${port}`;
  }
  daysNow(days: number): Date{
    return new Date(Date.now()+days*24*60*60*1000)
  }
}
